// El JqxNumberInput vuelve a aplicarle todas sus propiedades al widget cada vez que React lo redibuja, y el widget
// responde con su evento «change» aunque el valor no haya cambiado (por ejemplo un campo vacío). Si el manejador
// guarda un estado nuevo en cada aviso, el formulario se redibuja, el widget vuelve a avisar y se forma un ciclo que
// React corta con el error 185 «Maximum update depth exceeded» (pestaña pegada y «memoria insuficiente»).
//
// Devuelve true cuando el valor que llega del widget es el que el formulario ya tiene: en ese caso el manejador no
// debe tocar el estado. Un valor vacío (null, undefined, '' o NaN) equivale a otro vacío; el 0 NO es vacío, porque
// escribir 0 en un campo vacío es un cambio real. «12» y 12 son el mismo valor.
const isEmptyNumberInputValue = (value) =>
    value === null || value === undefined || value === '' || (typeof value === 'number' && Number.isNaN(value));

export const isSameNumberInputValue = (currentValue, newValue) => {
    const currentIsEmpty = isEmptyNumberInputValue(currentValue);
    const newIsEmpty = isEmptyNumberInputValue(newValue);

    if (currentIsEmpty || newIsEmpty) {
        return currentIsEmpty && newIsEmpty;
    }

    return Number(currentValue) === Number(newValue);
};
